import React from 'react';
import Layout from '../../components/Layout/Layout';
import MostPopularCard from '../../components/MostPopularCard/MostPopularCard';
import styles from './MostPopularCardPage.module.css';

const MostPopularCardPage = () => {
  const handleViewMoreClick = () => {
    console.log('View more clicked');
  };

  return (
    <Layout width="1440px">
      <div className={styles.mostPopularCardStack}>
        <MostPopularCard
          size="Desktop 1440"
          onViewMoreClick={handleViewMoreClick}
        />
      </div>
    </Layout>
  );
};

export default MostPopularCardPage;